import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToContractSettings = () => {
  const { navigation } = useNavigation()

  const to = navigation.settings.contracts_settings.agreementApprovals.fullPath()

  return <Navigate to={to} />
}

export default RedirectToContractSettings
